import { Action, createReducer, on } from '@ngrx/store';

import { DomainAction } from '../domain/domain.dispatcher';
import { EngagementSystem, initialEngagementSystem } from './engagement-system.model';

const engagementSystemReducer = createReducer(
  initialEngagementSystem,
  on(DomainAction.LoadSuccess, state => ({
    ...state,
    domainLoaded: true,
  }))
);

export function reducer(state: EngagementSystem | undefined, action: Action) {
  return engagementSystemReducer(state, action);
}
